import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

/**
 * Hook to check if the timeclock info when contacting support feature is enabled.
 *
 * This feature shows a multi-step intervention bottom sheet when workers click "Get Help"
 * during an in-progress shift, providing them with shift details and self-service options.
 *
 * Feature Flag: This hook checks the LaunchDarkly feature flag
 * "2025-18-orbit-timeclock-info-when-contacting-support" (TIMECLOCK_INFO_WHEN_CONTACTING_SUPPORT).
 * The flag must be enabled for the user in LaunchDarkly for the intervention to appear.
 *
 * @returns true if the feature flag is enabled for the current user, false otherwise.
 *         Defaults to false if the flag is not set or disabled.
 */
export function useIsTimeclockInfoWhenContactingSupportEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.TIMECLOCK_INFO_WHEN_CONTACTING_SUPPORT, {
    defaultValue: false,
  });
}
